import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

export function downloadCSV(filename, headers, rows) {
  const esc = (v) => `"${String(v ?? "").replace(/"/g, '""')}"`;
  const csv = [headers.map(esc).join(","), ...rows.map((r) => r.map(esc).join(","))].join("\n");
  const blob = new Blob(["\ufeff" + csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a"); a.href = url; a.download = filename; a.click();
  URL.revokeObjectURL(url);
}

export function downloadPDF(title, subtitle, headers, rows) {
  const doc = new jsPDF();
  doc.setFontSize(15); doc.text(title, 14, 16);
  doc.setFontSize(9); doc.setTextColor(120); doc.text(subtitle, 14, 22);
  autoTable(doc, { head: [headers], body: rows, startY: 28, styles: { fontSize: 8, cellPadding: 2 }, headStyles: { fillColor: [22, 128, 79] } });
  doc.save(title.replace(/\s+/g, "_") + "_" + new Date().toISOString().slice(0, 10) + ".pdf");
}

// Full recipe cost calculation as a printable PDF document.
export function downloadRecipePDF(name, c, subtitle) {
  const kr = (n) => `${(Number(n) || 0).toLocaleString("sv-SE", { maximumFractionDigits: 2 })} kr`;
  const pct = (n) => `${(Number(n) || 0).toLocaleString("sv-SE", { maximumFractionDigits: 1 })} %`;
  const doc = new jsPDF();
  doc.setFontSize(16); doc.text(name, 14, 18);
  doc.setFontSize(9); doc.setTextColor(120); doc.text(subtitle, 14, 24); doc.setTextColor(0);
  const body = (c.lines || []).map((l) => [l.name, `${l.qty} ${l.unit}`, kr(l.cost)]);
  autoTable(doc, { head: [["Råvara", "Mängd", "Kostnad"]], body, startY: 30, styles: { fontSize: 8, cellPadding: 2 }, headStyles: { fillColor: [22, 128, 79] } });
  let y = (doc.lastAutoTable?.finalY || 30) + 10;
  const line = (label, val, bold) => { doc.setFont(undefined, bold ? "bold" : "normal"); doc.setFontSize(10); doc.text(label, 14, y); doc.text(String(val), 196, y, { align: "right" }); y += 7; };
  line("Total råvarukostnad", kr(c.ingredientCost));
  line("Förpackningskostnad", kr(c.packaging));
  line("Arbetskostnad", kr(c.labor));
  line("Totalkostnad", kr(c.totalCost), true);
  line("Försäljningspris", kr(c.price));
  line("Bruttovinst", `${kr(c.grossKr)} (${pct(c.grossPct)})`, true);
  line("Food Cost", `${pct(c.foodCostPct)} (mål ${pct(c.target || 30)})`, true);
  line("Kostnad per portion", kr(c.costPerPortion));
  doc.save(`Kalkyl_${name.replace(/\s+/g, "_")}_${new Date().toISOString().slice(0, 10)}.pdf`);
}
